<template>
  <div>
    <el-upload
      ref="upload"
      class="singleimg-uploader"
      :auto-upload="false"
      :action="uploadImg"
      :show-file-list="false"
      accept=".webp,.bmp,.pcx,.tif,.gif,.jpeg,.tag,.exif,.fpx,.svg,.png,.ico,.jpg"
      :on-change="selectChange">
      <img v-if="imageUrl!==null&&imageUrl!==''&&imageUrl!==undefined" :src="imageUrl" :style="size!==null&&size!==undefined?`width:${size[0]}px;height:${size[1]}px`:''" class="singleimg">
      <i v-else class="el-icon-plus singleimg-uploader-icon" :style="size!==null&&size!==undefined?`width:${size[0]}px;height:${size[1]}px;line-height:${size[1]}px;`:''"></i>
    </el-upload>
    <el-dialog
        title="图片剪裁"
        width="400px"
        :visible.sync="dialogVisible"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false">
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="finish" size="small" :loading="loading">确认</el-button>
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import axios from 'axios'
export default {
  name: 'SingleImgCutting',
  components: {
    VueCropper
  },
  props: {
    value: {
      type: Object
    },
    oldurl: {
      type: String
    },
    size: {
      type: Array
    }
  },
  data() {
    return {
      uploadImg: process.env.VUE_APP_BASE_API + '/fileUpload/uploadImg',
      imageUrl: '',
      dialogVisible: false,
      loading: false,
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'jpg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: this.size, // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMove: false,
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      tempfile: null
    }
  },
  created() {
    if (this.oldurl !== null && this.oldurl !== undefined && this.oldurl !== '') {
      this.imageUrl = this.oldurl
    }
  },
  methods: {
    selectChange(file) {
      this.tempfile = file
      this.dialogVisible = true
      this.option.img = URL.createObjectURL(file.raw)
    },
    finish() {
      if (!this.loading) {
        this.loading = true
        this.$refs.cropper.getCropBlob((data) => {
          var formData = new FormData()
          formData.append('multipartFile', data)
          axios({
            method: 'post',
            url: process.env.VUE_APP_BASE_API + '/fileUpload/uploadImg',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: formData
          }).then(res => {
            this.loading = false
            this.dialogVisible = false
            this.imageUrl = res.data.data.img_url
            const _data = { imgid: res.data.data.dImgid, imgurl: res.data.data.img_url }
            this.$emit('input', _data)
          }).catch(err => {
            this.loading = false
            this.$message({
              type: 'error',
              message: '图片上传失败，请稍后重试'
            })
          })
        })
      }
    }
  }
}
</script>

<style>
.cropper {
  width: auto;
  height: 300px;
}
</style>
